import { GET_BIKES_FOR_PART_EX_REQUEST, GET_BIKES_FOR_PART_EX_SUCCESS, GET_BIKES_FOR_PART_EX_FAILURE } from '../constants/get_bikes_for_part_ex.constants';

export const getBikesForPartExRequest = params => ({
    type: GET_BIKES_FOR_PART_EX_REQUEST,
    params,
});

export const getBikesForPartExSuccess = payload => ({
    type: GET_BIKES_FOR_PART_EX_SUCCESS, payload,
});

export const getBikesForPartExFailure = error => ({
    type: GET_BIKES_FOR_PART_EX_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/get_bikes_for_par_ex.actions.js